import { checkUserHasRequiredPrivilege } from "@/helpers/utils";

const setPermissionVisibility = (el, binding) => {
  if (el.__permissionDisplay === undefined) {
    el.__permissionDisplay = el.style.display;
  }
  const allowed = checkUserHasRequiredPrivilege(binding.value);
  el.style.display = allowed ? el.__permissionDisplay : 'none';
};

export const permissionsDirective = {
  mounted: setPermissionVisibility,
  updated: setPermissionVisibility,
};
